import { Box } from '@mui/material';

import { BasicFormModalLayout } from 'modules/components/layer13';
import { CustomIcon } from 'modules/components/layer00';
import { SavePlanForm } from 'modules/components/layer12';

import React from 'react';
import { useParams } from 'react-router-dom';



export type SavePlanModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SavePlanModalProps) => {
  const params = useParams();

  return (
    <BasicFormModalLayout.FC
      {...props}
      title='Save Plan Information'
      subTitle='Enter Information about your finish to get started'
      headerIcon={<CustomIcon.large.FC icon='CREATOR' />}
    >
      <Box
        height='inherit'
      >
        <SavePlanForm.FC
          id={props.id}
          installationId={params.installationId ?? ''}
          versionOnly={false}
          projectId={params.projectId ?? ''}
          handleClose={props.handleClose}
        />
      </Box>
    </BasicFormModalLayout.FC>
  );
};
